// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
// @end dependencies

// @import components
import ButtonComponent, { ButtonComponentProps } from 'app_components/commons/Button/ButtonComponent';
import PopUpComponent from 'app_components/commons/PopUp/PopUpComponent';
import LoginModule from 'app_components/modules/login';
// @end components

// @import types
import { TypePermissionsForum } from 'app_types/admin/forum/forumTypes';
import { CombinedReducers } from 'app_events/index';
// @end types

// @import services
import UserService from 'app_services/user/userService';
// @end services

// @import hooks
import { useSelector } from 'react-redux';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ButtonWithLogin.scss'
import AlertComponent from 'app_components/commons/alert';
// @end styles

interface IButtonWithLoginProps {
  className?: string
  style?: CSSProperties
  id?: string
  classNameButton?: string
  styleButton?: CSSProperties
  idButton?: string
  children?: any
  disabled?: boolean
  variant?: ButtonComponentProps['variant'];
  loading?: boolean
  iconColor?: string
  permissions?: Permission[]
  type?: ButtonComponentProps['type'];
  loginText?: string
  showButtonOnDenegate?: boolean
  registerRedirect?: string
  onClick?: ()=>void
  onLoginSuccess?: () => void
}

// *
interface Permission{
  module: 'module:forums',
  permissions: TypePermissionsForum[]
}

const ButtonWithLogin: React.FC<IButtonWithLoginProps> = (props) => {

  const [openLogin, updateOpenLogin] = useState<boolean>(false);
  const [openErrorPermission, updateOpenErrorPermision] = useState<boolean>(false);
  const [denegate, updateDenegate] = useState<boolean>(false);
  const isAuth = useSelector((store: CombinedReducers) => store.auth.isAuth);
  const user = useSelector((store: CombinedReducers) => store.auth.user);

  const userService = new UserService();

  useEffect(() => {
    if (isAuth) {
      const permission = reviewAction();
      updateDenegate(!permission);
    }
  }, [isAuth])

  const handleClickButton = () => {
    // Revisar si el usuario esta logueado
    if (!isAuth) {
      updateOpenLogin(!openLogin);
      return;
    }
    sendOnClickEvent();
  }

  const handleLoginSuccess = () => {
    updateOpenLogin(false);
    if (props.onLoginSuccess) {
      props.onLoginSuccess()
    }
    sendOnClickEvent();
  }

  const sendOnClickEvent = () => {
    // Revisar si el rol tiene permitida la acción
    const permission = reviewAction();
    // Enviar el evento click del boton
    if (permission && props.onClick) {
      updateOpenErrorPermision(false);
      props.onClick();
    } else if (!permission) {
      if (props.showButtonOnDenegate) {
        updateOpenErrorPermision(true);
      }
    }
  }

  const reviewAction = (): boolean => {
    let response = true;
    if (props.permissions?.length) {
      props.permissions.forEach((modulePermission) => {
        if (modulePermission.permissions.length) {
          modulePermission.permissions.forEach((permission) => {
            response = userService.can(permission, modulePermission.module)
          })
        }
      })
    }
    return response;
  }

  const handleClosePopup = () => {
    updateOpenLogin(false);
    updateOpenErrorPermision(false);
  }

  return(
    <div
      className={`button_with_login-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <PopUpComponent
        content={
          openLogin ? <div>
            <LoginModule
              onHandlePasswordRecover={() => {}}
              onSubmit={() => {}}
              hideIcons
              hidePersonBusiness
              hideForgotPassword
              hideReturnToCampus
              registerRedirect={props?.registerRedirect}
              text={props.loginText ? props.loginText : 'Inicia sesión para continuar'}
              onLoginSuccess={handleLoginSuccess}
            />
          </div>:
          openErrorPermission ?
          <div>
            <AlertComponent
              description='No tienes permiso para realizar esta acción'
              type='warning'
            />
          </div>
          :null
        }
        show={openLogin || openErrorPermission}
        onClickClose={handleClosePopup}
        placement='auto'
      >
        {isAuth && denegate && !props.showButtonOnDenegate ? <div></div> :
          <ButtonComponent
            className={props.classNameButton}
            style={props.styleButton}
            id={props.idButton}
            variant={props.variant}
            type={props.type}
            iconColor={props.iconColor}
            loading={props.loading}
            disabled={props.disabled}
            onClick={handleClickButton}
          >
            {props.children}
          </ButtonComponent>
        }
      </PopUpComponent>
    </div>
  );
}

export default ButtonWithLogin;
